import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import begiImg from "../Utils/course-1.png";
import interImg from "../Utils/course-2.png";
import advImg from "../Utils/advanced.png";
import qrImage from "../Utils/spiiQr.jpg";
import { FaCreditCard } from "react-icons/fa";
import { motion } from "framer-motion";
import Particles from "react-tsparticles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../Utils/logo.png";

const Services = () => {
  const courses = [
    {
      id: 1,
      level: "beginner",
      title: "Technical Analysis Foundation",
      description:
        "The study of historical price movements and trading volume to predict future market trends.",
      img: begiImg,
    },
    {
      id: 2,
      level: "beginner",
      title: "Read Charts Perfectly",
      description:
        "Master interpreting price movements, trends, and market behavior accurately.",
      img: begiImg,
    },
    {
      id: 3,
      level: "beginner",
      title: "Multiple Time Frame Analysis",
      description:
        "Analyze the same financial instrument across different timeframes for a comprehensive understanding.",
      img: begiImg,
    },
    {
      id: 4,
      level: "intermediate",
      title: "Investment Plan",
      description:
        "A strategy to allocate your capital into different assets for long-term financial goals.",
      img: interImg,
    },
    {
      id: 5,
      level: "intermediate",
      title: "Intraday Trading",
      description:
        "Buy and sell financial instruments within the same trading day to profit from price movements.",
      img: interImg,
    },
    {
      id: 6,
      level: "intermediate",
      title: "Portfolio Management",
      description:
        "Understand risk and return concepts for effective portfolio diversification.",
      img: interImg,
    },
    {
      id: 7,
      level: "advanced",
      title: "Live Options Trading",
      description:
        "Buy and sell options contracts in real-time on the financial markets.",
      img: advImg,
    },
    {
      id: 8,
      level: "advanced",
      title: "Algorithmic Trading",
      description: "Automate trading strategies using algorithms and Python.",
      img: advImg,
    },
    {
      id: 9,
      level: "advanced",
      title: "Understanding Risk and Reward",
      description:
        "Understand potential loss (risk) and profit (reward) for informed trading decisions.",
      img: advImg,
    },
  ];

  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("all");
  const [showQR, setShowQR] = useState(false);
  const [showParticles, setShowParticles] = useState(false);

  useEffect(() => {
    filterCourses("all");
  }, []);

  const filterCourses = (level) => {
    setSelectedLevel(level);
    if (level === "all") {
      const beginner = courses.find((course) => course.level === "beginner");
      const intermediate = courses.find(
        (course) => course.level === "intermediate"
      );
      const advanced = courses.find((course) => course.level === "advanced");
      setFilteredCourses([beginner, intermediate, advanced].filter(Boolean));
    } else {
      setFilteredCourses(courses.filter((course) => course.level === level));
    }
  };

  const handlePayNow = () => {
    setShowQR(true);
    setShowParticles(true);

    setTimeout(() => {
      setShowQR(false);
      setShowParticles(false);
      toast.success("Thank you! Have a nice day! 😊");
    }, 15000);
  };

  return (
    <div
      className="container py-5 position-relative"
      style={{ backgroundColor: "#E5E7EB" }}
    >
      <ToastContainer position="top-right" autoClose={3000} />

      {showParticles && (
        <Particles
          options={{
            particles: {
              number: { value: 80 },
              size: { value: 5 },
              move: { speed: 5 },
              shape: { type: "circle" },
              opacity: { value: 0.8 },
              color: { value: ["#FFD700", "#00AEEF", "#FF4500"] },
            },
            interactivity: {
              events: { onClick: { enable: true, mode: "repulse" } },
            },
          }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 5,
          }}
        />
      )}

      <div
        style={{
          filter: showQR ? "blur(5px)" : "none",
          transition: "filter 0.3s ease-in-out",
        }}
      >

      <h2 className="text-center mb-4">
        <span style={{ color: "#002D62" }}>Our</span>{" "}
        <span style={{ color: "#00AEEF" }}>Courses</span>
      </h2>

      {/* Main Content with Blur Effect */}
      
        <div className="text-center mb-4">
          <button
            className={`btn mx-2 ${
              selectedLevel === "all" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => filterCourses("all")}
          >
            All Levels
          </button>
          <button
            className={`btn mx-2 ${
              selectedLevel === "beginner"
                ? "btn-primary"
                : "btn-outline-primary"
            }`}
            onClick={() => filterCourses("beginner")}
          >
            Beginner
          </button>
          <button
            className={`btn mx-2 ${
              selectedLevel === "intermediate"
                ? "btn-primary"
                : "btn-outline-primary"
            }`}
            onClick={() => filterCourses("intermediate")}
          >
            Intermediate
          </button>
          <button
            className={`btn mx-2 ${
              selectedLevel === "advanced"
                ? "btn-primary"
                : "btn-outline-primary"
            }`}
            onClick={() => filterCourses("advanced")}
          >
            Advanced
          </button>
        </div>

        <div className="row justify-content-center">
          {filteredCourses.map((course) => (
            <div className="col-md-4 mb-4" key={course.id}>
              <div className="card">
                <img
                  src={course.img}
                  className="card-img-top"
                  alt={course.title}
                />
                <div className="card-body">
                  <h5 className="card-title">{course.title}</h5>
                  <p className="card-text">{course.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-end mt-4">
          <motion.button
            className="btn d-flex align-items-center gap-2"
            onClick={handlePayNow}
            style={{
              background: "linear-gradient(45deg, #002D62, #00AEEF)",
              color: "#fff",
              fontSize: "18px",
              fontWeight: "bold",
              padding: "12px 24px",
              borderRadius: "8px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            }}
            whileHover={{
              scale: 1.1,
              boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
            }}
            whileTap={{
              scale: 0.95,
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
            }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <FaCreditCard size={20} /> Pay Now
          </motion.button>
        </div>
      </div>

      <div className="d-flex justify-content-end mt-4">
        {showQR && (
          <div
            className="position-fixed top-50 start-50 translate-middle p-4 rounded shadow-lg"
            style={{
              backgroundColor: "#f8f9fa",
              textAlign: "center",
              border: "2px solid #00AEEF",
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              zIndex: 1050,
              width: "300px",
            }}
          >
            <div
              className="rounded-circle p-2 mx-auto mb-3"
              style={{
                backgroundColor: "#fff",
                width: "80px",
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px solid #00AEEF",
                marginTop: "-50px",
              }}
            >
              <img src={logo} alt="Logo" style={{ width: "50px" }} />
            </div>

            <h5 className="fw-bold text-primary">
              Welcome to <span style={{ color: "#002D62" }}>S</span>
              <span style={{ color: "#00AEEF" }}>P</span>
              <span style={{ color: "#00AEEF" }}>I</span> Trading
            </h5>

            <p className="text-dark">Scan QR code to proceed with payment</p>

            <img
              src={qrImage}
              alt="QR Code"
              className="img-fluid mb-3"
              style={{ width: "200px", borderRadius: "10px" }}
            />

            <div className="d-flex justify-content-center">
              <button
                className="btn d-flex align-items-center gap-2"
                style={{
                  backgroundColor: "#00AEEF",
                  color: "#fff",
                  borderRadius: "8px",
                  padding: "8px 16px",
                }}
                onClick={() => {
                  setShowQR(false);
                }}
              >
                <FaCreditCard /> Hide QR
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
